/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";
import PartForm from "./PartForm.js";
import { useLocation } from "react-router-dom";

const EditPart = () => {

    const { state } = useLocation();
    const effectivities = state.EFFECTIVITY_ID
        .split(",").map(eff => {
           return {value: eff.toString().trim(), label: eff.toString().trim()}
        }
    );

    return (
        <PartForm
            id={"Edit"}
            mode={"edit"}
            partStatus={state.ACTIVE_FLAG.toLowerCase()}
            wbStatus={state.PART_TYPE_CODE.toLowerCase()}
            mpn={state.PART_ID}
            ata={state.ATA}
            vendor={state.VENDOR}
            effectivities={effectivities}
            description={state.DESCRIPTION}
        />
    );

}

export default EditPart;
